import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import krinvyteam from "../assets/images/krinvy_partner.png";
import "./Become-a-Partner.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Scrolltop from "../components/Scrolltop";
import WhatsAppChatButton from "../components/Whatsapp";
import Cosection2 from "../components/Cosection2";

const BecomeAPartner = ({ showCallModal, setShowCallModal }) => {
  const navigate = useNavigate();
  const modalIntervalRef = useRef(null);

  useEffect(() => {
    // Function to show modal only if not currently showing
    const showModalIfNotOpen = () => {
      if (!showCallModal) {
        setShowCallModal(true);
      }
    };

    // Start interval only if modal is not currently open
    if (!showCallModal) {
      modalIntervalRef.current = setInterval(showModalIfNotOpen, 120000); // 2 minutes
    }

    return () => {
      // Clear interval on unmount
      if (modalIntervalRef.current) {
        clearInterval(modalIntervalRef.current);
        modalIntervalRef.current = null;
      }
    };
  }, [showCallModal, setShowCallModal]);

  // Additional effect to restart interval when modal closes
  useEffect(() => {
    if (!showCallModal && !modalIntervalRef.current) {
      modalIntervalRef.current = setInterval(() => {
        if (!showCallModal) {
          setShowCallModal(true);
        }
      }, 120000);
    }
    
    return () => {
      if (modalIntervalRef.current) {
        clearInterval(modalIntervalRef.current);
        modalIntervalRef.current = null;
      }
    };
  }, [showCallModal, setShowCallModal]);

  const serviceCategories = [
    {
      id: 1,
      title: "Financial Services",
      description:
        "Comprehensive financial solutions for businesses operating in India and the US",
      services: [
        {
          title: "Tax & Accounting",
          desc: "End-to-end tax compliance including GST, Income Tax, TDS filings in India and Federal/State tax filings in US. Our team provides:",
          details: [
            "Monthly/quarterly bookkeeping with software integration",
            "Financial statement preparation as per Indian GAAP/US GAAP",
            "Tax planning and advisory for optimal liability",
            "Representation during tax audits and notices",
            "Cross-border taxation advisory for international operations",
          ],
        },
        {
          title: "Payroll Management",
          desc: "Automated payroll processing with compliance coverage for:",
          details: [
            "Salary processing with bank integration",
            "PF, ESI, PT, and other statutory deductions in India",
            "401(k), Social Security, Medicare in US",
            "Employee self-service portals",
            "Leave and attendance management integration",
            "Custom payroll reports and analytics",
          ],
        },
        {
          title: "Business Registration",
          desc: "Turnkey incorporation services including:",
          details: [
            "Company name approval and reservation",
            "DSC and DIN procurement",
            "MOA/AOA drafting for Indian entities",
            "Articles of Organization for US LLCs",
            "Tax ID registration (PAN/TAN in India, EIN in US)",
            "Business licensing and compliance setup",
            "Post-incorporation compliance calendar",
          ],
        },
      ],
    },
 {
    id: 2,
    title: "Legal & Compliance",
    description:
      "End-to-end legal support for business protection and governance",
    services: [
      {
        title: "Corporate Legal Support",
        desc: "Comprehensive legal solutions for businesses:",
        details: [
          "Company incorporation documentation",
          "Shareholder agreements drafting",
          "Board meeting minutes and resolutions",
          "Corporate governance advisory",
          "Compliance calendar management",
        ],
      },
      {
        title: "Intellectual Property",
        desc: "IP protection and registration services:",
        details: [
          "Trademark registration (India and US)",
          "Patent filing assistance",
          "Copyright registration",
          "IP portfolio management",
          "Infringement protection strategies",
        ],
      },
      {
        title: "Regulatory Compliance",
        desc: "Industry-specific compliance solutions:",
        details: [
          "MCA annual filings for Indian companies",
          "US state-specific compliance filings",
          "Sector-specific licensing",
          "Environmental compliance",
          "Data protection regulations",
        ],
      },
    ],
  },
    {
      id: 3,
      title: "Digital Solutions",
      description:
        "Custom technology solutions to power your digital transformation",
      services: [
        {
          title: "Web Development",
          desc: "Full-spectrum web solutions including:",
          details: [
            "Responsive website design with mobile-first approach",
            "E-commerce platforms with payment gateway integration",
            "CMS implementation (WordPress, Shopify, custom)",
            "Web application development with React/Node.js",
            "SEO-friendly architecture and semantic markup",
            "Performance optimization and security hardening",
            "ADA compliance and accessibility features",
          ],
        },
        {
          title: "IT & Software Solutions",
          desc: "Custom software development services:",
          details: [
            "Business process automation tools",
            "CRM/ERP customization and integration",
            "Cloud migration and hybrid cloud solutions",
            "Database design and management",
            "API development and system integration",
            "Legacy system modernization",
            "IT infrastructure consulting",
          ],
        },
        {
          title: "Website & IT Maintenance",
          desc: "Ongoing support and maintenance packages:",
          details: [
            "24/7 website monitoring and uptime management",
            "Scheduled security patches and updates",
            "Performance optimization and speed tuning",
            "Backup management and disaster recovery",
            "Content updates and technical support",
            "Analytics reporting and insights",
            "SSL certificate management",
          ],
        },
      ],
    },
    {
      id: 4,
      title: "Marketing & Branding",
      description:
        "Complete marketing solutions to amplify your brand presence",
      services: [
        {
          title: "SEO & Digital Marketing",
          desc: "Data-driven marketing strategies including:",
          details: [
            "Comprehensive SEO audits and technical optimization",
            "Keyword research and content strategy",
            "Local SEO for geographic targeting",
            "PPC campaign management (Google Ads, Meta)",
            "Conversion rate optimization",
            "Marketing automation setup",
            "ROI tracking and analytics",
          ],
        },
        {
          title: "Graphic & Branding Design",
          desc: "Visual identity and branding services:",
          details: [
            "Logo design and brand style guides",
            "Corporate identity systems (business cards, letterheads)",
            "Presentation design and investor pitch decks",
            "Product packaging and labeling",
            "Infographics and data visualization",
            "Brand positioning strategy",
            "Visual content creation",
          ],
        },
        {
          title: "Offline Marketing",
          desc: "Traditional marketing collateral:",
          details: [
            "Brochures and product catalogs",
            "Trade show displays and banners",
            "Restaurant menus and table tents",
            "Direct mail campaigns",
            "Vehicle wraps and signage",
            "Point-of-sale materials",
            "Print advertising design",
          ],
        },
        {
          title: "Social Media Management",
          desc: "Comprehensive social media services:",
          details: [
            "Platform-specific content strategy",
            "Content calendar and scheduling",
            "Community management and engagement",
            "Influencer partnership programs",
            "Paid social media advertising",
            "Performance analytics reporting",
            "Crisis management protocols",
          ],
        },
      ],
    },
    {
      id: 5,
      title: "Business Growth",
      description: "Strategic consulting to accelerate your business expansion",
      services: [
        {
          title: "Business Strategy & Consulting",
          desc: "Growth-focused advisory services:",
          details: [
            "Market entry strategy development",
            "Competitive landscape analysis",
            "Business model innovation",
            "Funding strategy and investor readiness",
            "Operational efficiency optimization",
            "Pricing strategy formulation",
            "Exit planning and valuation",
          ],
        },
        {
          title: "Content & Copywriting",
          desc: "Strategic content creation services:",
          details: [
            "Website copy and messaging architecture",
            "Blog content and thought leadership articles",
            "Product descriptions and category pages",
            "Email marketing campaigns and sequences",
            "Whitepapers and case studies",
            "Scriptwriting for videos and podcasts",
            "Technical documentation",
          ],
        },
        {
          title: "E-commerce Growth Solutions",
          desc: "Specialized e-commerce services:",
          details: [
            "Conversion funnel optimization",
            "Shopping cart abandonment strategies",
            "Product page optimization",
            "Retargeting campaign setup",
            "Email/SMS marketing automation",
            "Loyalty program design",
            "Marketplace integration",
          ],
        },
      ],
    },
{
    id: 6,
    title: "HR & Operations",
    description: "Workforce solutions to build and manage your team",
    services: [
      {
        title: "HR Support",
        desc: "Comprehensive HR solutions:",
        details: [
          "Job description development",
          "Candidate sourcing and screening",
          "Interview process design",
          "Offer letter and employment contracts",
          "Employee handbook development",
          "Performance management systems",
          "HR compliance audits",
        ],
      },
      {
        title: "Recruitment Services",
        desc: "End-to-end hiring solutions:",
        details: [
          "Talent acquisition strategy",
          "Employer branding assistance",
          "Candidate assessment tools",
          "Background verification services",
          "Onboarding program design",
          "Temporary staffing solutions",
          "Executive search services",
        ],
      },
      {
        title: "Business Operations",
        desc: "Operational support services:",
        details: [
          "Employee onboarding kits",
          "Corporate identity materials",
          "Branded merchandise programs",
          "Digital asset management",
          "Office space planning",
          "Vendor management systems",
          "Operational documentation",
        ],
      },
      ],
    },
  ];

  const partnershipBenefits = [
    {
      title: "Cross-Referral Network",
      desc: "Gain access to our established client network while we actively promote your services to our customer base, creating a reciprocal lead generation system.",
      benefits: [
        "Access to premium client network",
        "Reciprocal marketing exposure",
        "Increased lead generation",
        "Shared customer acquisition costs",
      ],
      bestFor: [
        "Service providers with complementary offerings",
        "Businesses targeting similar customer segments",
        "Companies looking to expand their reach",
      ],
    },
    {
      title: "Revenue Sharing",
      desc: "Our transparent commission structure ensures you earn competitive percentages on all successful referrals and joint client engagements.",
      benefits: [
        "Recurring revenue streams",
        "Clear commission structure",
        "Performance-based earnings",
        "No upfront costs or commitments",
      ],
      bestFor: [
        "Sales professionals and consultants",
        "Business development experts",
        "Companies with existing customer relationships",
      ],
    },
    {
      title: "Refer & Earn",
      desc: "Turn your professional network into earnings. For every client you refer who engages our services, you receive immediate financial rewards and ongoing partnership benefits.",
      benefits: [
        "Simple enrollment process",
        "Immediate payouts",
        "Tiered reward structure",
        "No sales experience required",
      ],
      bestFor: [
        "Individual professionals with strong networks",
        "Freelancers and consultants",
        "Anyone looking for passive income opportunities",
      ],
    },
  ];



   return (
    <>
      <Navbar />
      <div className="partner-container">
        {/* Hero Section */}
        <section className="partner-hero">
          <div className="hero-content">
            <h1>Strategic Business Partnerships</h1>
            <p className="hero-subtitle">
              At Krinvy, we cultivate partnerships that extend beyond
              transactional relationships to create lasting business value
              through our comprehensive service ecosystem.
            </p>
          </div>
          <div className="hero-image">
            <img src={krinvyteam} alt="Krinvy Team" />
          </div>
        </section>

        {/* Partnership Value Proposition */}
        <section className="value-proposition">
          <div className="section-header">
            <h2>Why Partner With Krinvy?</h2>
            <p className="section-subtitle">
              We build mutually beneficial relationships that drive sustainable
              growth for both.
            </p>
          </div>
          <div className="benefits-grid">
            {partnershipBenefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>

                <div className="benefit-details">
                  <h4>Key Benefits:</h4>
                  <ul className="benefit-list">
                    {benefit.benefits.map((item, i) => (
                      <li key={`benefit-${i}`}>{item}</li>
                    ))}
                  </ul>

                  <h4>Best For:</h4>
                  <ul className="best-for-list">
                    {benefit.bestFor.map((item, i) => (
                      <li key={`bestfor-${i}`}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Service Ecosystem */}
        <section className="service-ecosystem">
          <div className="section-header">
            <h2>Our Service Ecosystem</h2>
            <p className="section-subtitle">
              Comprehensive solutions across all business functions to serve
              your clients' complete needs
            </p>
          </div>

          <div className="service-categories">
            {serviceCategories.map((category) => (
              <div key={category.id} className="category-card">
                <div className="category-header">
                  <h3>{category.title}</h3>
                  <p className="category-desc">{category.description}</p>
                </div>
                <div className="services-list">
                  {category.services.map((service, idx) => (
                    <div key={idx} className="service-item">
                      <h4>{service.title}</h4>
                      <p className="service-desc">{service.desc}</p>
                      <ul className="service-details">
                        {service.details.map((detail, i) => (
                          <li key={i}>{detail}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      <Scrolltop />
      <WhatsAppChatButton />
      <Cosection2 setShowCallModal={setShowCallModal} />
      <Footer />
    </>
  );
};

export default BecomeAPartner;